// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/commesse/:id/documenti',
    requestBody: null,
    response: '{"documenti":"Documento[]"}'
  },
  {
    method: 'POST',
    endpoint: '/api/commesse/:id/documenti',
    requestBody: '{"file":"File","nome":"string","categoria":"string","note":"string"}',
    response: '{"ok":"true","documento":"Documento"}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/commesse/:id/documenti/:docId',
    requestBody: null,
    response: '{"ok":"true"}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
